import { mapDataCloudfrontURL } from "../map/MapConstants";
import { getZippedGeoJson } from "../map/ZippedGeoJsonReader";
import { Source, Layer } from "react-map-gl";
import { useState, useEffect } from "react";
import { emptyGeojson } from "../riskAssessment/defaultSourceLayer";
import { makeColorMatchList } from "../util/MapUtilsTS";

export const concessionSubstanceColor = {
  MANGANESE: "#4B0082",
  COPPER: "#228B22",
  NICKEL: "#D87093",
  IRON: "#8B0000",
  COAL: "#2F4F4F",
};

export const concessionMenuItems = [
  { color: concessionSubstanceColor.MANGANESE, label: "Manganese" },
  { color: concessionSubstanceColor.COPPER, label: "Copper" },
  { color: concessionSubstanceColor.NICKEL, label: "Nickel" },
  { color: concessionSubstanceColor.IRON, label: "Iron" },
  { color: concessionSubstanceColor.COAL, label: "Coal" },
];

export const ConcessionLayer: React.FC<{
  active: boolean;
}> = ({ active }) => {
  const [concessionGeoJsonData, setConcessionGeoJsonData] = useState<GeoJsonData>(emptyGeojson);

  const getConcessionMap = async (): Promise<GeoJsonData> => {
    // s3://s3.amazonaws.com/cys-realerisk-mapdata/mining/cys_data_minex_bra_gfw_mineconcessions/cys_data_minex_bra_gfw_mineconcessions.zip
    const url = `${mapDataCloudfrontURL}mining/cys_data_minex_bra_gfw_mineconcessions/cys_data_minex_bra_gfw_mineconcessions.zip`;
    return getZippedGeoJson(url);
  };

  useEffect(() => {
    if (active) {
      getConcessionMap().then((geoJsonRes: GeoJsonData) => {
        setConcessionGeoJsonData(geoJsonRes);
      });
    } else {
      setConcessionGeoJsonData(emptyGeojson);
    }
  }, [active]);

  return (
    <Source key="concession" id="concession-src" type="geojson" data={concessionGeoJsonData}>
      <Layer
        type="fill"
        paint={{
          "fill-color": ["match", ["get", "subs_en"], ...makeColorMatchList(concessionSubstanceColor)],
          "fill-opacity": 0.8,
        }}
        source="concession-src"
        id="concession-layer"
      />
    </Source>
  );
};
